import React from 'react';
import CoachingConstants from 'coaching/CoachingConstants';
import CoachingHeading from 'coaching/components/CoachingHeading';
import { CoachingReservation } from 'coaching/containers/GetAvailableReservationsContainer';
import CoachingSelfServeReservationDetails from 'coaching/components/CoachingSelfServeView/CoachingSelfServeReservationDetails';
import Button from 'components/ButtonDeprecated';
import Copy from 'components/Copy';
import Display from 'components/Display';
import Divider from 'components/Divider';
import EventTracking from 'lib/EventTracking';
import Image from 'components/Image';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';

export type Props = {
  reservation?: CoachingReservation;
  userTimezone: string;
  childName?: string;
  userEmail?: string;
  childEmail?: string;
  participantUUID?: string;
  selectedSubject?: string;
};

export default function CoachingSelfServeSuccessView(props: Props) {
  React.useEffect(() => {
    EventTracking.trackKey('coaching.self_schedule_purchase.success.view');
  }, []);

  const { reservation, userTimezone, childName, userEmail, childEmail, selectedSubject } = props;
  const emailConfirmationText =
    userEmail || childEmail ? (
      <Row>
        <Text size="small">
          We’ve sent a confirmation to <Text weight="semibold">{userEmail ?? 'your email'}</Text>
          {childEmail && userEmail !== childEmail && (
            <>
              {' '}
              and <Text weight="semibold">{childEmail}</Text>
            </>
          )}
          .
        </Text>
      </Row>
    ) : null;

  return (
    <React.Fragment>
      <CoachingHeading size="xsmall">Your session is confirmed!</CoachingHeading>
      {emailConfirmationText}
      {reservation && childName && (
        <CoachingSelfServeReservationDetails
          reservation={reservation}
          childName={childName}
          userTimezone={userTimezone}
          selectedSubject={selectedSubject}
        />
      )}
      <Divider size="medium" />
      <CoachingHeading size="xsmall" level="2">
        Next: Check out the Coaching dashboard
      </CoachingHeading>
      <Copy size="small">
        It’s your hub for connecting with your coach, joining a session, rescheduling and more.
      </Copy>
      <MediaObject figure="right" bottom>
        <Button
          color="koolaid"
          level="primary"
          size="medium"
          to={CoachingConstants.COACHING_HOME_ROUTE}>
          View dashboard
        </Button>
        <Display hide="480">
          <Image width={150} src={require('assets/images/coaching/paper_plane_doodle.png')} />
        </Display>
      </MediaObject>
    </React.Fragment>
  );
}
